/* eslint-disable class-methods-use-this */
// eslint-disable-next-line class-methods-use-this
import { observable, action, makeObservable, computed } from 'mobx';
import * as API from '@/api';
import { deviceData } from '@/utils/deviceCheck';
import { clearSessionStorage, profile } from '@/utils/common';
import { meeting } from './index';
import { clearLocalPassword } from '@/utils/localStorage';
import { setSentryUser } from '@/utils/sentry';

class User {
  memberAvatarUrl: any;
  constructor() {
    makeObservable(this);
  }

  // 云信会议 id
  @observable cid: number = Number(window.sessionStorage.getItem('cid')) || 0;

  @observable sessionId: string = window.sessionStorage.getItem('sessionId') || '';

  // 游客 id

  @observable user: defs.api.WebSideSession = {};
  @observable uid: string = window.sessionStorage.getItem('uid') || '';

  @observable yxuid: string = window.sessionStorage.getItem('yxuid') || '';

  @observable avatarUrl: string = window.sessionStorage.getItem('avatarUrl') || '';

  @observable name: string = window.sessionStorage.getItem('name') || '';

  @observable waterMark: defs.api.WatermarkConfiguration = JSON.parse(
    window.sessionStorage.getItem('watermark') || '{}'
  );

  @observable isOnline = true;

  @action
  async login(authType: string, name: string, meetingId: string, avatarId: number, pwd: string) {
    const data: API.LoginRequest = {
      authType,
      guestAvatarId: avatarId || 10,
      guestName: name,
      meetingId: Number(meetingId),
      pwd: decodeURIComponent(pwd),
    };
    let resp;
    resp = await API.login(data);
    if (resp?.data && resp.status === 1) {
      this.sessionId = resp.data?.sessionId || '';
      this.uid = resp.data.uid!;
      this.yxuid = String(resp.data.yxUid);
      this.avatarUrl = resp.data?.memberAvatarUrl || '';
      this.name = resp.data.memberName!;
      this.waterMark = resp.data.watermark || {};
      window.sessionStorage.setItem('waterMark', JSON.stringify(resp.data.watermark));
      window.sessionStorage.setItem('sessionId', resp.data?.sessionId || '');
      window.sessionStorage.setItem('uid', resp.data.uid!);
      window.sessionStorage.setItem('yxuid', resp.data?.yxUid!.toString());
      resp.data.memberAvatarUrl &&
        window.sessionStorage.setItem('avatarUrl', resp.data.memberAvatarUrl);
      window.sessionStorage.setItem('name', resp.data.memberName!);
      setSentryUser({
        username: resp.data.memberName,
        id: `${meetingId}-${resp.data.memberName}`,
        meetingId,
        yxuid: resp.data.yxUid,
        uid: resp.data.uid,
      });
      DATracker.login(resp.data.uid);
      Scout.setUserData({
        userName: resp.data.memberName!,
        id: resp.data.uid,
        yxUid: resp.data.yxUid,
      });
      return resp;
    }
  }

  @action
  async logout(meetingId: string) {
    await API.logout(meetingId);
    clearSessionStorage();
    clearLocalPassword(meetingId);
    DATracker.logout();
  }

  @action
  async getUserInfo(meetingId: string) {
    const resp = await API.getUserInfo(meetingId);
    if (resp.data && resp.status === 1) {
      this.sessionId = resp.data.sessionId!;
      this.uid = resp.data.uid!;
      this.yxuid = String(resp.data.yxUid);
      this.avatarUrl = resp.data.memberAvatarUrl;
      this.name = resp.data.memberName!;
      this.waterMark = resp.data.watermark || {};
      this.user = resp.data;
      // window.sessionStorage.setItem('cid', resp.data.cid);
      window.sessionStorage.setItem('waterMark', JSON.stringify(resp.data.watermark));
      window.sessionStorage.setItem('sessionId', resp.data.sessionId!);
      window.sessionStorage.setItem('uid', resp.data.uid!);
      window.sessionStorage.setItem('yxuid', String(resp.data.yxUid));
      resp.data.memberAvatarUrl &&
        window.sessionStorage.setItem('avatarUrl', resp.data.memberAvatarUrl);
      window.sessionStorage.setItem('name', resp.data?.memberName || '');
      setSentryUser({
        username: resp.data.memberName,
        id: `${meetingId}-${resp.data.memberName}`,
        meetingId,
        yxuid: resp.data.yxUid,
        uid: resp.data.uid,
        // cid: resp.data.cid,
      });
    }
    return resp;
  }

  setAvatarUrl(url: string) {
    if (url) {
      this.avatarUrl = url;
      window.sessionStorage.setItem('avatarUrl', url);
    }
  }

  @action
  async reportDeviceStatus(
    cid: string,
    audioOn: API.DEVICE_STATUS_REQUEST,
    videoOn: API.DEVICE_STATUS_REQUEST
  ) {
    await API.reportDeviceStatus(cid, audioOn, videoOn);
  }

  @action
  async updateDeviceStatus(cid: string, type: API.DEVICE_TYPE, on: API.DEVICE_STATUS_REQUEST) {
    await API.updateDeviceStatus(cid, type, on);
  }

  @action
  async quiet(cid: string, on: API.DEVICE_STATUS_REQUEST, mode: API.SPACE_STATUS) {
    await API.quiet(cid, on, mode);
  }

  @action
  async hangUp(
    meetingId: string,
    cid: number,
    uid: string,
    isGreat: boolean,
    feedbackIds?: number[],
    remark?: string
  ) {
    await API.hangUp(meetingId, cid, uid, isGreat, feedbackIds, remark);
    if (feedbackIds && feedbackIds.length > 0) {
      feedbackIds?.forEach((id) => {
        const question = meeting.questions.find((i) => i.id === id);
        if (!question) {
          return;
        }
        DATracker.track('meeting_feedback', {
          yxChannelId: cid,
          profile,
          meetingMemberUid: uid,
          meetingId,
          meetingFeedbackScore: isGreat ? 'good' : 'bad',
          meetingFeedbackType: question.type,
          meetingFeedbackOption: question.doc,
        });
      });
    } else {
      DATracker.track('meeting_feedback', {
        yxChannelId: cid,
        profile,
        meetingMemberUid: uid,
        meetingId,
        meetingFeedbackScore: 'good',
      });
    }
  }

  @action
  async setIsOnline(isOnline: boolean) {
    this.isOnline = isOnline;
  }

  @computed
  get mid() {
    return this.uid + this.sessionId;
  }
}

export default User;
